import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "@/lib/firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { toast } from "@/components/ui/use-toast";

export const sendContactMessage = createAsyncThunk(
  "contact/sendContactMessage",
  async ({ name, email, message }, { rejectWithValue }) => {
    try {
      await addDoc(collection(db, "contactMessages"), {
        name,
        email,
        message,
        submittedAt: serverTimestamp(),
        createdAt: serverTimestamp(),
      });
      toast({
        title: "Message Sent!",
        description:
          "Thank you for contacting PartsLokator. We'll get back to you soon.",
        variant: "default",
      });
    } catch (error) {
      toast({
        title: "Error Sending Message",
        description:
          error.message || "Could not send your message. Please try again.",
        variant: "destructive",
      });
      return rejectWithValue(error.message || "Failed to send message");
    }
  }
);
